var _statusColor;
import PropTypes from 'prop-types';
import { elo as theme } from '../../themes';
import { variants } from '../../util';
export var statusColor = (_statusColor = {}, _statusColor[variants.POSITIVE] = {
  color10: theme.colors.mint10,
  color20: theme.colors.mint20,
  color30: theme.colors.mint30,
  color40: theme.colors.mint40
}, _statusColor[variants.NEGATIVE] = {
  color10: theme.colors.red10,
  color20: theme.colors.red20,
  color30: theme.colors.red30,
  color40: theme.colors.red40
}, _statusColor[variants.INFORMATIVE] = {
  color10: theme.colors.cyan10,
  color20: theme.colors.cyan20,
  color30: theme.colors.cyan30,
  color40: theme.colors.cyan40
}, _statusColor[variants.ATTENTION] = {
  color10: theme.colors.honey10,
  color20: theme.colors.honey20,
  color30: theme.colors.honey30,
  color40: theme.colors.honey40
}, _statusColor[variants.ACCENT] = {
  color10: theme.colors.accent10,
  color20: theme.colors.accent20,
  color30: theme.colors.accent30,
  color40: theme.colors.accent40
}, _statusColor);
var progressIndicatorPropType = {
  percentage: PropTypes.number.isRequired,
  flat: PropTypes.bool,
  animationDurationInSeconds: PropTypes.number,
  status: PropTypes.oneOf([variants.NEGATIVE, variants.POSITIVE, variants.INFORMATIVE, variants.ATTENTION, variants.ACCENT]),
  size: PropTypes.oneOf(['small', 'regular'])
};
export default progressIndicatorPropType;